module.exports = __webpack_public_path__ + "img/8.aca82b1c.jpeg";